<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden && item.children">
      <router-link
        v-if="
          hasOneShowingChildren(item.children) &&
          !item.children[0].children &&
          !item.alwaysShow
        "
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item
          :index="item.path + '/' + item.children[0].path"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <i
            v-if="item.children[0].meta && item.children[0].meta.icon"
            :class="'el-icon-' + item.children[0].meta.icon"
          ></i>
          <span
            v-if="
              item.children[0].meta &&
              item.children[0].meta.title &&
              languageType == 0
            "
            slot="title"
            >{{ item.children[0].meta.title }}</span
          >
          <span
            v-if="
              item.children[0].meta &&
              item.children[0].meta.title &&
              languageType == 1
            "
            slot="title"
            >{{ item.children[0].meta.title1 }}</span
          >
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name || item.path" :key="item.name">
        <template slot="title">
          <i
            v-if="item.meta && item.meta.icon"
            :class="'el-icon-' + item.meta.icon"
          ></i>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>
          <!--支持外链功能-->
          <a
            v-else-if="child.path.startsWith('http')"
            v-bind:href="child.path"
            target="_blank"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <i
                v-if="child.meta && child.meta.icon"
                :class="'el-icon-' + child.meta.icon"
              ></i>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
              {{ child }}
            </el-menu-item>
          </a>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <i
                v-if="child.meta && child.meta.icon"
                :class="'el-icon-' + child.meta.icon"
              ></i>
              <span v-if="child.meta && child.meta.title" slot="title">{{
                child.meta.title
              }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { getCookie } from "@/utils/support";
import languageData from "@/utils/language.json";
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 语言类型
      languageType: getCookie("language"),
      languageData,
    };
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter((item) => {
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue